import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ConfirmDialog } from "security-app/components/common/Modal";
import { useModalContext } from "common/contexts";
import { useUpdateSecurityEvent } from "security-app/hooks/useSecurityEventsAPI";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
function ConfirmStatusChange() {
  const { t } = useTranslation("enterprise_security_events");
  const {
    entity: { securityEvent, newStatus, onCancelCB },
    setEntity,
    setModal
  } = useModalContext();
  const { updateSecurityEvent, updatingSecurityEvent } = useUpdateSecurityEvent();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const onConfirm = async () => {
    const payload = {
      owner: securityEvent.owner,
      notes: securityEvent.notes,
      status: newStatus
    };
    await updateSecurityEvent({ id: securityEvent.event_id, data: payload });
    sendEventActionTelemetry("SET_STATUS", false);
    setModal(null);
    setEntity(null);
  };
  const onCancel = () => {
    onCancelCB == null ? void 0 : onCancelCB();
    setModal(null);
    setEntity(null);
  };
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      onConfirm,
      confirmDisabled: updatingSecurityEvent,
      isLoading: updatingSecurityEvent,
      confirmText: t("confirm_status_change.confirm_text"),
      onCancel,
      title: t("confirm_status_change.title")
    },
    /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "confirm_status_change.description",
        values: { status: SECURITY_EVENT_STATUSES[newStatus] },
        components: { bold: /* @__PURE__ */ React.createElement("b", null) }
      }
    ))
  );
}
export default ConfirmStatusChange;
